import { getApis } from 'library/Apis';
import { CooperativaDTO } from 'models/entidades';
import { toRequest } from 'utils/RequestUtils';
import api from './api';

const getEndpoint = (version: number, path = '/logradouro') => {
  return `${getApis().apis.backofficeProjetos}v${version}${path}`;
};

export const getCooperativasOptions = (...coops: string[]) => {
  const url = `${getEndpoint(1)}/coops/false`;
  return toRequest<CooperativaDTO[]>(api.post, [url, coops]);
};
